import React from 'react';
import { ListGroup, ListGroupItem, Badge } from 'reactstrap';
import SystemLabel from '../../system/SystemLabel/SystemLabel';
import { archiveConstants } from '../contstants/archive.contstants';
import UnsplashLogo from '../../assets/icons/unsplash_logo.svg';

export default class ArchiveSidebar extends React.Component {
  render() {
    const { objects, navigate, filterType } = this.props;
    return (
      <ListGroup>
        <ListGroupItem style={{ border: 0, backgroundColor: filterType == archiveConstants.IMAGE ? '#eee' : undefined }} onClick={() => navigate(archiveConstants.CLIENT_STORAGE, archiveConstants.IMAGE)} className="justify-content-between"><i className="fa fa-image" />{"  "}
          <SystemLabel name="Images" />
          <Badge pill color="info"
            style={{ color: '#fff', marginLeft: '2px' }}>{" "}
            {objects ? objects.filter(o => {
              return archiveConstants.IMAGE.includes(o.type.substring(o.type.lastIndexOf('/') + 1)) && o
            }).length : 0}
          </Badge>
        </ListGroupItem>
        <ListGroupItem style={{ border: 0, backgroundColor: filterType == archiveConstants.OTHERS ? '#eee' : undefined }} onClick={() => navigate(archiveConstants.CLIENT_STORAGE, archiveConstants.OTHERS)} className="justify-content-between"><i className="fa fa-pdf" />{"  "}
          <SystemLabel name="OtherFiles" />
          <Badge pill color="info"
            style={{ color: '#fff', marginLeft: '2px' }}>{" "}
            {objects ? objects.filter(o => {
              return archiveConstants.OTHERS.includes(o.type.substring(o.type.lastIndexOf('/') + 1)) && o
            }).length : 0}
          </Badge>
        </ListGroupItem>
        <ListGroupItem style={{ border: 0, backgroundColor: filterType == archiveConstants.UNSPLASH ? '#eee' : undefined }} onClick={() => navigate(archiveConstants.UNSPLASH,archiveConstants.UNSPLASH)} className="justify-content-between">
          <img src={UnsplashLogo} height={15} width={15} /> <SystemLabel name="Unsplash" /></ListGroupItem>
        <ListGroupItem style={{ border: 0, backgroundColor: filterType == archiveConstants.FONT ? '#eee' : undefined }} onClick={() => navigate(archiveConstants.CLIENT_STORAGE, archiveConstants.FONT)} className="justify-content-between"><i className="fa fa-font" />{"  "}
          <SystemLabel name="Fonts" /> <Badge pill color="info" style={{ color: '#fff' }}>{objects ? objects.filter(o => {
            return archiveConstants.FONT.includes(o.type.substring(o.type.lastIndexOf('/') + 1)) && o
          }).length : 0}</Badge></ListGroupItem>
      </ListGroup>
    );
  }
}
